//just trigger a build
import {
    ApplicationEnvironmentTypeEnum,
    IAppDomainConfig
} from "./env.configs.interface";
import {UndefinedString} from "./types/nullable-types";


function getProductionApiOrigin(): string {
    return 'https://aeroitalia-gateway.azure-api.net/mobileappprod-api';
}

function getStageApiOrigin(): string {
    return 'https://aeroitalia-gateway.azure-api.net/stage-ibe-api';
}

function getTestApiOrigin(): string {
    return 'https://aeroitalia-gateway.azure-api.net/mobileapptest-api';
}

function getDevApiOrigin(): string {
    return 'https://localhost:5001';
}


function createProductionEnvironment(domainOrigin: string): IAppDomainConfig {
    return  {
        environmentType: ApplicationEnvironmentTypeEnum.Production,
        domainOrigin: domainOrigin,
        apiOrigin: getProductionApiOrigin()
    };
}

function createStageEnvironment(domainOrigin: string): IAppDomainConfig {
    return  {
        environmentType: ApplicationEnvironmentTypeEnum.Stage,
        domainOrigin: domainOrigin,
        apiOrigin: getStageApiOrigin()
    };
}


function createTestEnvironment(domainOrigin: string): IAppDomainConfig {
    return   {
        environmentType: ApplicationEnvironmentTypeEnum.Test,
        domainOrigin: domainOrigin,
        apiOrigin: getTestApiOrigin()
    };
}

function createDevEnvironment(options: {domainOrigin: string; apiOrigin: string}): IAppDomainConfig {
    return   {
        environmentType: ApplicationEnvironmentTypeEnum.Development,
        domainOrigin: options.domainOrigin,
        apiOrigin: options.apiOrigin
    };
}

export class EnvConfigs {

    constructor() {
        this._currentDomain = this._loadCurrentDomain();
    }

    private readonly _preferredApiOrigin: UndefinedString = process.env.REACT_APP_PREFERRED_API;

    private readonly _currentDomain: IAppDomainConfig;

    public readonly appDomains = [
        createProductionEnvironment('https://www.aeroitalia.com'),
        createProductionEnvironment('https://searchmask.aeroitalia.com'),
        createProductionEnvironment('https://prod-searchmask.azureedge.net'),

        createStageEnvironment('https://stage-searchmask.azureedge.net'),
        createStageEnvironment('https://stage1.aeroitalia.com'),

        createTestEnvironment('https://test-searchmask.azureedge.net'),
        createTestEnvironment('https://test.aeroitalia.com'),

        createDevEnvironment({domainOrigin: 'http://localhost:3000', apiOrigin: getDevApiOrigin()}),
        createDevEnvironment({domainOrigin: 'http://localhost:4100', apiOrigin: getDevApiOrigin()})
    ];


    get airlineWebapiOrigin(): string {
        return this._currentDomain.apiOrigin;
    }

    private _findDomainByCurrentLocation(): IAppDomainConfig {
        let currentLocation = new URL(window.location.href);

        for(let domain of this.appDomains) {
            const domainOrigin = new URL(domain.domainOrigin);
            if(currentLocation.origin.toLowerCase() === domainOrigin.origin.toLowerCase()) {
                if(this._preferredApiOrigin) {
                    return domain;
                }
                return domain;
            }
        }

        const firstProdDomain = this.appDomains.find(d => d.environmentType === ApplicationEnvironmentTypeEnum.Production);
        if(firstProdDomain) {
            return firstProdDomain;
        }

        throw new Error('No domain configuration found for current domain');
    }

    private _loadCurrentDomain(): IAppDomainConfig {

        const domain = this._findDomainByCurrentLocation();

        const preferredApi = this._preferredApiOrigin?.toLowerCase();
        if(preferredApi) {
            return {
                ...domain,
                apiOrigin: preferredApi
            }
        } else {
            return domain;
        }

    }

    get currentEnvironmentType(): ApplicationEnvironmentTypeEnum {
        return this._currentDomain.environmentType;
    }

    get isProduction(): boolean {
        return this._currentDomain.environmentType === ApplicationEnvironmentTypeEnum.Production;
    }

    /*
    getInitialApiOrigin(): string {
        return this._findDomainByCurrentLocation().apiOrigin;
    }


*/

}
